import { isConsoleDebugEnabled } from './consoleDebug';

/** Console tracing for admin-web boot, auth guard, and routing. */
export const ADMIN_DEBUG = isConsoleDebugEnabled();

export function logAdmin(label: string, data?: Record<string, unknown>): void {
  if (!isConsoleDebugEnabled()) return;
  const prefix = '[admin-web]';
  if (data !== undefined) {
    console.log(prefix, label, data);
  } else {
    console.log(prefix, label);
  }
}

export function logAdminError(label: string, error: unknown, extra?: Record<string, unknown>): void {
  if (!isConsoleDebugEnabled()) return;
  console.error('[admin-web]', label, error, extra ?? '');
}
